import { styled } from 'styled-components';

export const StyleWrapper = styled.div`
  padding: 15px 0px;
  padding-top: 30px;
  padding-bottom: 0;
  padding-top: 0;
  display: flex;
  flex-direction: column;
`;

export const StyleSubTitle = styled.div`
  color: red;
  font-size: 14px;
  max-width: 90%;
  text-align: center;
  margin-top: 0px;
  margin-bottom: 0px;
  margin-left: auto;
  margin-right: auto;
`;

export const StyleQrcodeWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;

  width: 100%;
  padding: 0 30px;
`;

export const StyleAddress = styled.div`
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 14px;
  text-align: center;
  color: var(--pcm-body-color-secondary);
  max-width: 80%;
  white-space: pre-wrap;
  word-break: break-all;
  margin-left: auto;
  margin-right: auto;
`;

export const Stylefooter = styled.div`
  width: 100%;
  margin-top: 20px;

  svg {
    .bg {
      fill: var(--pcm-primary-button-hover-background) !important;
      stroke: var(--pcm-primary-button-color) !important;
    }
    path {
      stroke: var(--pcm-primary-button-color) !important;
    }
  }
  .copied {
    svg {
      .bg {
        fill: var(--pcm-accent-color) !important;
        stroke: var(--pcm-accent-color) !important;
      }
    }
  }
`;
